import React, { useState } from 'react';
import CMSPreviewToolbar from './CMSPreviewToolbar';
import CMSPreviewRenderer from './CMSPreviewRenderer';

export default function CMSPreviewPanel({
  section,
  form = {},
  categoryOptions = [],
  navigationOptions = [],
  isExpanded = false,
  onToggleExpand,
}) {
  const [viewport, setViewport] = useState('desktop'); // 'desktop' | 'tablet' | 'mobile'

  const getContainerWidth = () => {
    if (viewport === 'mobile') return 'max-w-[375px] w-full shadow-2xl rounded-3xl border-8 border-slate-800 my-4';
    if (viewport === 'tablet') return 'max-w-[768px] w-full shadow-2xl rounded-2xl border-4 border-slate-700 my-4';
    return 'w-full shadow-sm rounded-xl border border-slate-200';
  };

  return (
    <div className="flex flex-col h-full bg-slate-100/90 overflow-hidden select-none border-l border-slate-200">
      {/* Toolbar */}
      <CMSPreviewToolbar
        viewport={viewport}
        onViewportChange={setViewport}
        isExpanded={isExpanded}
        onToggleExpand={onToggleExpand}
        section={section}
        status={form.status || form.website_status || 'draft'}
      />

      {/* Canvas Area */}
      <div className="flex-1 overflow-y-auto p-4 md:p-6 flex justify-center items-start">
        <div className={`transition-all duration-300 bg-white overflow-hidden flex flex-col ${getContainerWidth()}`}>
          {/* Simulated Browser Chrome if tablet/mobile */}
          {(viewport === 'mobile' || viewport === 'tablet') && (
            <div className="bg-slate-800 text-slate-300 px-4 py-1.5 flex items-center justify-between text-[10px] select-none">
              <div className="flex items-center gap-1">
                <div className="w-2 h-2 rounded-full bg-red-500" />
                <div className="w-2 h-2 rounded-full bg-yellow-500" />
                <div className="w-2 h-2 rounded-full bg-green-500" />
              </div>
              <span className="font-mono text-slate-400">
                {viewport === 'mobile' ? '375 x 667 (Mobile)' : '768 x 1024 (Tablet)'}
              </span>
              <span className="text-[9px] font-bold uppercase text-slate-400">Preview</span>
            </div>
          )}

          {/* Actual Live Preview Renderer */}
          <div className="flex-1 overflow-x-hidden">
            <CMSPreviewRenderer
              section={section}
              form={form}
              categoryOptions={categoryOptions}
              navigationOptions={navigationOptions}
              viewport={viewport}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
